import React from "react";

export default class TabBarSpacer extends React.Component {
	public render(): React.ReactNode {
		return (
			<div className="tab-bar-spacer">&nbsp;</div>
		);
	}
};